import {
  DataPackageJson,
  DataPackageRecord,
  KeyValuePair,
  Tag,
} from '@piv/lib/db-types'

export type DataPackage = DataPackageJson & { dateFrom: string | null }

export type DataPackageDetail = {
  dataPackage: KeyValuePair
  subAsset: KeyValuePair
  metaData: MetaData
}

export type DataPackageBasicInfo = Pick<DataPackageRecord, 'id' | 'displayName'>

export type MetaData = {
  dateFrom: string | null
  brandNames: string[]
  regionNames: string[]
  currencyNames: string[]
}

export interface GetResponse {
  packages: DataPackage[]
}

export const FilterDefaults = {
  asset: [] as string[],
  subAsset: [] as string[],
  region: [] as string[],
  brand: [] as string[],
  currency: [] as string[],
  products: [] as string[],
  instruments: [] as string[],
}

export type Filters = typeof FilterDefaults

export type GetQueryParams = Partial<Filters> & { q?: string }

export type GetFiltersQueryParams = Partial<{
  [key in keyof Filters]: string | string[]
}>
export type GetFiltersResponse = {
  asset: KeyValuePair[]
  subAsset: KeyValuePair[]
  region: KeyValuePair[]
  brand: KeyValuePair[]
  currency: KeyValuePair[]
  products: Tag[]
  instruments: Tag[]
}
export const GetFiltersDefaults: GetFiltersResponse = {
  asset: [],
  subAsset: [],
  region: [],
  brand: [],
  currency: [],
  products: [],
  instruments: [],
}
